(() => {
  'use strict';

  const initialiseHeader = () => {
    const header = document.querySelector('[data-header]');
    const announcement = document.querySelector('.announcement');
    if (!header) return;

    let scheduled = false;
    const render = () => {
      const scrolled = window.scrollY > 12;
      header.classList.toggle('is-scrolled', scrolled);
      announcement?.classList.toggle('is-scrolled', scrolled);
      scheduled = false;
    };
    const schedule = () => {
      if (scheduled) return;
      scheduled = true;
      window.requestAnimationFrame(render);
    };

    render();
    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('pageshow', render);
    window.addEventListener('resize', schedule, { passive: true });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialiseHeader, { once: true });
  else initialiseHeader();
})();
